export default function(theme) {
  return {
    rootCheckbox: {
      marginRight: 9,
      padding: 0,
      color: "#a3a3a3"
    },
    checked: {},
    rootLabelContainer: {
      margin: "0 0 9px 0",
      width: "100%",
      display: "inline-flex"
    },
    rootLabel: {
      fontSize: 16,
      fontWeight: 500,
      color: theme.colors.black54,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      "@media (max-width: 600px)": {
        whiteSpace: "normal"
      }
    }
  }
}
